import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { AlertRoutingModule } from './alert-routing.module';
import { ZoneModule } from '../zone/zone.module';



@NgModule({
  declarations: [AlertComponent],
  imports: [
    CommonModule,
    SharedModule,
    AlertRoutingModule,
    ZoneModule
  ]
})
export class AlertModule { }